<div class="race-cards-controls">
    @if (showControl) {
        <div class="race-cards-show-option" (click)="toggleShowOptionChange()">
            <span class="show-option" [ngClass]="{ active: showMore }">
                <span [textContent]="toggleInfoText"></span>
            </span>
        </div>
    }

    @if (sortOptionsEnabled) {
        <lazy-component
            moduleUri="@lazy-modules-module/sortByOptions/sort-by-options.module#SortByOptionsModule"
            [inputs]="{ sortBy: sortBy }"
            class="sort-by-section">
        </lazy-component>
    }
</div>
